import React, {
  useState,
  //useEffect
} from "react";
import _ from "lodash";
import { Loader } from "../../atoms";
import { InputText } from "../../forms";

const ERMToolITASDownload = (props) => {
  const [values, setValues] = useState({
    email: "",
    key: "",
  });
  const [isLoading, setIsLoading] = useState(false);
  const [errors, setErrors] = useState({});

  // useEffect(() => {
  //   return () => {
  //     // disable loading if on page back
  //     // setIsLoading(false);
  //   };
  // }, []);

  const handleSubmission = () => {
    console.clear();
    setErrors({});
    const formType = props?.data?.type;
    const acceptedToolTypes = {
      erm: "electoral-risk-management-tool",
      itas: "integritas-threat-assessment-system",
    };
    const isAcceptedType = acceptedToolTypes.hasOwnProperty(formType);

    if (!isAcceptedType) {
      setErrors({
        general_error: ["Invalid form type."],
      });
      return;
    }

    const errors = {};
    Object.keys(values).forEach((field) => {
      if (!values[field]) {
        errors[field] = ["This field is required"];
      }
    });

    if (Object.keys(errors).length > 0) {
      setErrors(errors);
      return; // Has errors, exit the function
    }

    const toolPageAlias = acceptedToolTypes[formType];
    const formUrl = `/data-tools/tools/${toolPageAlias}/step2?email=${values.email}&key=${values.key}`;
    setIsLoading(true);
    window.location.href = encodeURI(formUrl);
  };

  return (
    <React.Fragment>
      <div className="grid sm:grid-cols-2 gap-8">
        <InputText
          label="Email address*"
          type="email"
          value={values.email}
          onChange={(e) => {
            setValues({ ...values, email: e.target.value });
          }}
          error={_.get(errors, "email[0]")}
        />

        <InputText
          label="Key*"
          value={values.key}
          onChange={(e) => {
            setValues({ ...values, key: e.target.value });
          }}
          error={_.get(errors, "key[0]")}
        />
      </div>

      <div className="text-mobileS md:text-desktopS">
        <p>
          Enter the email you stated when requesting the key and to which the
          confirmation email was sent.
        </p>

        {_.get(errors, "general_error[0]") && (
          <div className="text-red-500 font-bold mb-2">
            {_.get(errors, "general_error[0]")}
          </div>
        )}
      </div>

      <div className="flex items-center gap-x-4 mb-8">
        <button className="btn btn-s--pill" onClick={() => handleSubmission()}>
          Submit
        </button>
        {isLoading && <Loader />}
      </div>
    </React.Fragment>
  );
};

export default ERMToolITASDownload;
